'use strict';
// Tab menu
// Define variables
var tabLabels = document.querySelectorAll("#tabs li");
var tabPanes = document.getElementsByClassName("tab-contents");

function activateTab(e) {
  e.preventDefault();

  
  // Deactivate all tabs
  tabLabels.forEach(function(label, index){
    label.classList.remove("active");
  });
  [].forEach.call(tabPanes, function(pane, index){
    pane.classList.remove("active");
  });
  
  // Activate current tab
  this.classList.add("active");
  var clickedTab = this.getAttribute("data-href");
  document.querySelector(clickedTab).classList.add("active");
}

// Apply event listeners
tabLabels.forEach(function(label, index){
  label.addEventListener("click", activateTab);
});

window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type === 'close' || e.detail.type === 'submit') {
    // Replace 'kl-active' with the specific class name you see in your dev tools
    document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.querySelector('[role="dialog"]').style.display = 'none';
    
    // Fallback: Ensure overflow is set back to auto
    document.body.style.overflow = 'auto';
  }
});
